export var FilterMultiplePassType;
(function (FilterMultiplePassType) {
    FilterMultiplePassType["merge"] = "merge";
    FilterMultiplePassType["chain"] = "chain";
})(FilterMultiplePassType || (FilterMultiplePassType = {}));
//# sourceMappingURL=filterMultiplePassType.enum.js.map